/**
 * LYCHEE-SIGN-V1 build-time signing key for the TEST backend (lychee-store client).
 *
 * Shared by the non-prod environment files (environment.ts / .dev.ts) so the test keypair lives in
 * one place. Prod uses its own key injected at deploy and does NOT import this.
 *
 * This key is matched by the public key in TEST_VECTORS.md and is intentionally non-secret —
 * any signing key shipped in a web bundle is extractable (see the plan's threat model).
 */
export const TEST_SIGNING = {
  keyId: 'test-key-1',
  privateKeyPkcs8Pem: `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCgDhHFXJeO7Z9+
0GmRtNVJHjqU/grhmwd1P0oXEPCXBGvUIwvjRbfIN51Ui6RvlhTPSMV4sPAZdgy7
nwr8gjHTkEQYZ/dqgQSSsFTpf6AqmQgyWajUhTg8N8GIeEe88268fheWH/8Jvnof
NhjLTAy5GHelbxFjmLQ7sJz39YiO8zT4egq3Cee0SN311VD6g5n6f+qVI51w4XUh
K4N+7eaOLUncGbayQTrWVXR04sSYOAxgDK2j3XCoTB91mLV3sK+wVNbIPOcD7R9q
FzIuZcRQsGyrp0MVA0CvIt0IEh5hrCEOHVQS04fR0z1KTsRfoJdl1WcoCT5J0/fB
Z+POFjq/AgMBAAECggEAJoGcBuZy1AEZKTJM47AkzBWItIW16ncYwT17vrblmv+G
TaAs4P3J7FJs+IUsB2iNEx2H3LR83zNGdvEZfIx6HlML/u8sWCQ4DG59zztUNktg
7HQjqRVv5RTo68M8Rxot3w1a8VQ7UIXR7aZfKrHeMb3QMy3YeiSn3+Bqs0EQHIvH
H+NJNQLlKi4gAzALkZSBwdYwDAe23dqRtS13VbI1z6fUyXhi2gE1Pd9prS9+0C2b
Ukb2CtN7Ve2l6CI8cVB72PDm1EoiRvXfod4DShOFkXx+F901oVx5AFqGVp1WXjHo
j6wgtia6WlLhfKWR9nJcFvG96TJS9y/oyDqUGa5n4QKBgQDMyk+eqaU50OdaWiPq
mjrjLGe+wVfo0lycVRov5ALe9NK6miDkYL/CfIj5wQfOaC6sxoaXtOra+kiznLCh
Hzplid1chfpBa2FJUcg3v+z3NSbm6Fz+8oWL/ZJmJDU6Hhfg4aFARFdxldeGlRog
loysbLFRT9oQXUvC9AMeVg/Y8QKBgQDIFAS0CjWTEHsl97AOZZu95RHju+ZJSX9y
ftP+Q4ZSsdw/xoHaFtvWkc3JGT/GFZjMTfiUc4J4K+UP0prAjnteeK0HcqVCAACd
jDGanmvRXIOzUQeClkmlWl223AJ6s8S4bXv1HXvuuu6lfRdvz/TyPgCglfwILqH1
L4l+K5/OrwKBgAh8qegNZ8eJnMzlx29FjQM1J+eD47zGWwgvjrJFZMkQpFsPYCWW
zNumhZa0JTqsnqKSZ6mJ2eHRVYn8CGXlAWqL2BypgMGNTa7YMM/+qDdmgII5RwFZ
06cFjzekcIBEFwE+2IvtSSJv70qoizimhJXwuzh/cq4S77zYl/h94JJBAoGBAKH5
ktUubrDgZtIV8zG0kKDrEdCMDaLHHaZThswRXm0UEHqQ+g7U8qSC5VYoWrjCQzEi
7ltAKB+haY+lsCKzNq0EhQ/CgIct+VGSbZX/KsoTW4uPzcSqZnS286dV9avgXSHx
gKivdeWO8CSJYK/kayixiVB4G9GD7xnPoj/CkV2BAoGBALAKN05ctsjluXj7Fx2s
UOf7E4nxZDpMa/+58qN1HHv0gGSFvHxnF6ZiGUfLLHG+J5WyykQpVXGBGbsPaX6X
ZVztwqjUG58xFCYQ12LmwI4BKEWGOEbFiPZ2Kk6ku8DjK8r7wxAFixgSLRGEcfih
WZtbP9YDmfzMKWQATTT0cAfv
-----END PRIVATE KEY-----`,
};
